module.exports = __webpack_public_path__ + "img/16.237ed996.png";